import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ICreditReferenceLabel, IUser } from '../../../core/models';
import { CommonService } from '../../../core/services/common.service';
import { SelfUtilityService } from '../../../core/services/self-utility.service';
import { UserService } from '../../../core/services/user.service';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { HelperService } from '../../../core/services/helper.service';

@Component({
  selector: 'app-credit-reference',
  templateUrl: './credit-reference.component.html',
  styleUrls: ['./credit-reference.component.scss']
})
export class CreditReferenceComponent implements OnInit {
  creditReferenceForm: FormGroup;
  requestInProcess: boolean = false;
  termsChecked: boolean = false;
  //creditReferenceLabel: ICreditReferenceLabel;
  creditlbl: ICreditReferenceLabel;
  creditRefRequestInfoPopupLbl: string = '';
  constructor(private formBuilder: FormBuilder,
    private commonService: CommonService,
    private userService: UserService,
    private selfUtilityService: SelfUtilityService, private languageTranslationService: LanguageTranslationService, private helperService: HelperService) { }

  ngOnInit() {
    //initText
    this.creditReferenceForm = this.formBuilder.group({
      email: new FormControl(),
      confirmEmail: new FormControl()
    })
   // this.loadPageLanguageText();
    this.LoadLanguageTranslationData();
  }

  
  ////#region label declaration 
  //public creditReference = {
  //  confirmDialogOpened: false,
  //  emailLbl: "Email",
  //  confirmEmail: "Confirm Email",
  //  submit: "Submit",
  //  cancel: "Cancel",
  //  //modify text as per requirement
  //  termsAndConditionsPartOne: "In submitting this request you represent and warrant that you are authorized by your company to make this request, and that the report being sought is   to be provided for a lawful purpose. In consideration for Kawneer accommodating your request you understand and agree that any and all information   released is being provided without any representation or warranty, express or implied, as to the accuracy or completeness of the information provided,   or its suitability for whatever your intended",
  //  acceptTermsLbl: "I Accept Terms & Conditions",
  //  isInvalidEmail: false,
  //  isInvalidConfirmEmail: false,
  //  isEmailFormatInValid: false,
  //  emailNotMatched: false,
  //  isSubmitted: false,
  //  invalidEmail: "Email address is invalid",
  //  confirmEmailMatch: "Email and Confirm Email must match.",
  //  emailText: "",
  //}
  ////#endregion

  //#region Language translate
  LoadLanguageTranslationData() {
    const controlNameList = [{ controlName: "acceptTermsLbl" },
    { controlName: "confirmEmailLbl" },
    { controlName: "creditRefTermsAndConditionsLbl" },
    { controlName: "emailLbl" },
    { controlName: "pageTitle" },
    { controlName: "submitLbl" },
    { controlName: "termsAndConditionsPartOne" },
    { controlName: "termsAndConditionsPartTwo" },
    { controlName: "invalidEmailLbl" },
    { controlName: "confirmEmailMatchLbl" },
    { controlName: "creditRefRequestInfoLbl" },
    { controlName: "creditConfirmTitleLbl" },
    { controlName: "emailAddressAtRequestLbl" }
    ];
    const componentName = "creditReference";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length>0) {
      this.creditlbl = response[response.length-1];
    }
    
    console.log(response);
  }

  //#endregion

  //#region label declaration 
  public creditReference = {
    confirmDialogOpened: false,
    emailLbl: "Email",
    confirmEmail: "Confirm Email",
    submitLbl: "Submit",
    cancelLbl: "Cancel",
    //modify text as per requirement
    termsAndConditionsPartOne: "In submitting this request you represent and warrant that you are authorized by your company to make this request, and that the report being sought is   to be provided for a lawful purpose. In consideration for Kawneer accommodating your request you understand and agree that any and all information   released is being provided without any representation or warranty, express or implied, as to the accuracy or completeness of the information provided,   or its suitability for whatever your intended",
    acceptTermsLbl: "I Accept Terms & Conditions",
    isInvalidEmail: false,
    isInvalidConfirmEmail: false,
    isEmailFormatInValid: false,
    emailNotMatched: false,
    isSubmitted: false,
    invalidEmailLbl: "Email address is invalid",
    confirmEmailMatchLbl: "Email and Confirm Email must be match.",
    creditRefRequestInfoLbl: "Your Credit Reference Request information has been sent to the following",
    emailAddressAtRequestLbl: "Email address at your request",
    creditConfirmTitleLbl: "Credit Reference confirmation",
    creditRefRequestErrorLbl: "We are unable to process your Credit Reference request. Please reach out to BCSCredit@arconic.com to proceed with obtaining Credit Reference information.",
    emailText: "",
    confirmEmailLbl:""
  }
  //#endregion

  //#region validation operation

  public validateCreditReferenceForm(): boolean {
    //need to read
    let isValid = true;
    const controls = this.creditReferenceForm.controls;
    if (controls.email.value) {
      //checking proper email format is entered or not
      const res = this.helperService.isEmailFormatValid(controls.email.value);
      if (!res) {
        this.creditReference.isEmailFormatInValid = true;
        isValid = false;
        this.creditReference.isInvalidEmail = true;
      } else {
        this.creditReference.isEmailFormatInValid = false;
        this.creditReference.isInvalidEmail = false;
      }
    } else {
      if (this.creditReference.isSubmitted) {
        this.creditReference.isEmailFormatInValid = false;
        this.creditReference.isInvalidEmail = true;
      }
      isValid = false;
    }
    if (controls.confirmEmail.value) {
      if (controls.email.value) {
        if (controls.email.value != controls.confirmEmail.value) {
          this.creditReference.emailNotMatched = true;
          this.creditReference.isInvalidConfirmEmail = true;
          isValid = false;
        } else {
          this.creditReference.emailNotMatched = false;
          this.creditReference.isInvalidConfirmEmail = false;
        }
      } 
    } else {
      if (this.creditReference.isSubmitted) {
        this.creditReference.isInvalidConfirmEmail = true;
        this.creditReference.emailNotMatched = false;
      }      
      isValid = false;
    }

    return isValid;
  }

  
  //#endregion
  //#region Credit reference form save
  submitCreditReferenceRequest() {
    this.creditReference.isSubmitted = true;
    if (!this.validateCreditReferenceForm()) {
      return;
    }
    
    this.requestInProcess = true;
    var body = {
      email: this.creditReferenceForm.value.email,
      customerNumber: this.userService.readUserObject.customerNumber,
      userName: this.userService.readUserObject.userName
    }
    this.selfUtilityService.submitCreditReferenceRequest(body).subscribe(response => {
      if (response)
        this.creditRefRequestInfoPopupLbl = this.creditlbl.creditRefRequestInfoLbl ? this.creditlbl.creditRefRequestInfoLbl : this.creditReference.creditRefRequestInfoLbl;
      else
        this.creditRefRequestInfoPopupLbl = this.creditReference.creditRefRequestErrorLbl;

      this.creditReference.emailText = body.email;
      this.creditReference.confirmDialogOpened = true;
      this.creditReferenceForm.reset();
      this.requestInProcess = false;
      this.creditReference.isSubmitted = false;
    })
  }

  confirmDialogClose() {
    this.creditReference.confirmDialogOpened = false;
    this.creditRefRequestInfoPopupLbl = '';
  }
  //#endregion
}


